export const DataTableCellEditorVariableNames = {
  FontSize: '--data-table-editor-font-size',
  FontWeight: '--data-table-editor-font-weight',
} as const;
